import {
  Backdrop,
  Box,
  Button,
  Card,
  Collapse,
  Fade,
  Grid,
  IconButton,
  makeStyles,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import componentStyles from "assets/theme/views";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";

const useStyles = makeStyles({
  ...componentStyles,
  th: {
    color: "#32325d",
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 600,
    lineHeight: 1.5,
    marginBottom: ".5rem",
    textAlign: "center",
    padding: "15px 0",
  },
  td: {
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 500,
    textAlign: "center",
    padding: "10px 0px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  widthLarge: {
    width: "15vw",
    maxWidth: "15vw",
  },
});

export default function TableSolicitacaoDevolucaoNota({
  productList,
  setProductList,
}) {
  const [openRows, setOpenRows] = useState({});
  const [showingPhoto, setShowingPhoto] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const classes = useStyles();

  console.log("productList", productList);

  const toggleRow = (invoiceId) => {
    setOpenRows((prev) => ({
      ...prev,
      [invoiceId]: !prev[invoiceId],
    }));
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) =>
      Math.min(showingPhoto.images.length - 1, prev + 1)
    );
  };

  const handleCloseModal = () => {
    setShowingPhoto(null);
    setCurrentImageIndex(0);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Card classes={{ root: classes.cardRoot }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow style={{ borderBottom: "1px solid #ddd" }}>
                    <TableCell></TableCell>
                    <TableCell class={classes.th}>Nota Fiscal</TableCell>
                    <TableCell class={classes.th}>Número de Série</TableCell>
                    <TableCell class={classes.th}>Data Emissão</TableCell>
                    <TableCell class={classes.th}>
                      Motivo de Devolucão
                    </TableCell>
                    <TableCell class={classes.th}>Motivo de Defeito</TableCell>
                    <TableCell class={classes.th}>Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productList.map((invoice, index) => {
                    const invoiceId = invoice.NumeroNf || index;
                    const isOpen = !!openRows[invoiceId];
                    return (
                      <>
                        <TableRow
                          key={invoiceId}
                          style={{
                            borderBottom: isOpen ? "" : "1px solid #ddd",
                          }}
                        >
                          <TableCell class={classes.td}>
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() => toggleRow(invoiceId)}
                            >
                              {isOpen ? (
                                <KeyboardArrowUpIcon />
                              ) : (
                                <KeyboardArrowDownIcon />
                              )}
                            </IconButton>
                          </TableCell>
                          <TableCell class={classes.td}>
                            {invoice.NumeroNf}
                          </TableCell>
                          <TableCell class={classes.td}>
                            {invoice.SerieNf}
                          </TableCell>
                          <TableCell class={classes.td}>
                            {invoice.DataEmissaoNf}
                          </TableCell>
                          <TableCell class={classes.td}>
                            {invoice.items && invoice.items[0]
                              ? invoice.items[0].motivo
                              : ""}
                          </TableCell>
                          <TableCell class={classes.td}>
                            {invoice.items && invoice.items[0]
                              ? invoice.items[0].defeito
                              : ""}
                          </TableCell>
                          <TableCell class={classes.td}>
                            <Tooltip title="Deletar nota fiscal">
                              <IconButton
                                aria-label="delete"
                                onClick={() => {
                                  setProductList(
                                    productList.filter(
                                      (item) =>
                                        item.NumeroNf !== invoice.NumeroNf
                                    )
                                  );
                                }}
                              >
                                <Box
                                  component={DeleteIcon}
                                  width="1.25rem!important"
                                  height="1.25rem!important"
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                        {isOpen && (
                          <TableRow
                            key={`${invoiceId}-collapse`}
                            style={{ borderBottom: "1px solid #ddd" }}
                          >
                            <TableCell
                              colSpan={9}
                              style={{
                                padding: "0 1rem",
                              }}
                            >
                              <Collapse
                                in={isOpen}
                                timeout="auto"
                                unmountOnExit
                              >
                                <TableContainer>
                                  <Table
                                    style={{
                                      border: "1px solid #ddd",
                                      borderRadius: "15px",
                                    }}
                                  >
                                    <TableHead>
                                      <TableRow
                                        style={{
                                          borderBottom: "1px solid #ddd",
                                        }}
                                      >
                                        <TableCell class={classes.th}>
                                          Cód Pedido
                                        </TableCell>
                                        <TableCell class={classes.th}>
                                          Cód Produto
                                        </TableCell>
                                        <TableCell
                                          class={`${classes.th} ${classes.widthLarge}`}
                                          style={{ maxWidth: "20vw" }}
                                        >
                                          Descrição
                                        </TableCell>
                                        <TableCell class={classes.th}>
                                          Qtd NF
                                        </TableCell>
                                        <TableCell class={classes.th}>
                                          Qtd Devolvida
                                        </TableCell>
                                        <TableCell class={classes.th}>
                                          Valor unitário
                                        </TableCell>
                                        <TableCell class={classes.th}>
                                          Valor Total
                                        </TableCell>
                                        <TableCell class={classes.th}>
                                          Devolução
                                        </TableCell>
                                        <TableCell class={classes.th}>
                                          Imagens
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {invoice.items.map((product) => {
                                        console.log('product', product);
                                        return (
                                          <TableRow key={product.Codigo}>
                                            <TableCell class={classes.td}>
                                              {product.IdPedido}
                                            </TableCell>
                                            <TableCell class={classes.td}>
                                              {product.idProduto}
                                            </TableCell>
                                            <TableCell
                                              class={`${classes.td} ${classes.widthLarge}`}
                                            >
                                              {product.name}
                                            </TableCell>
                                            <TableCell class={classes.td}>
                                              {product.QtdFaturada}
                                            </TableCell>
                                            <TableCell class={classes.td}>
                                              {product.QuantidadeDevolvida}
                                            </TableCell>
                                            <TableCell class={classes.td}>
                                              {product.ValorUnitario}
                                            </TableCell>
                                            <TableCell class={classes.td}>
                                              {product.ValorTotal}
                                            </TableCell>
                                            <TableCell class={classes.td}>
                                              {product.quantidade}
                                            </TableCell>
                                            <TableCell class={classes.td}>
                                              <div
                                                style={{ textAlign: "center" }}
                                              >
                                                <Tooltip title="Vizualizar Imagens">
                                                  <div
                                                    className={
                                                      classes.imageIcon
                                                    }
                                                    onClick={() =>
                                                      setShowingPhoto(product)
                                                    }
                                                  >
                                                    <i className="fas fa-images" />
                                                  </div>
                                                </Tooltip>
                                              </div>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      </Grid>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={Boolean(showingPhoto)}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Fade in={Boolean(showingPhoto)}>
          <div
            className={classes.paper}
            style={{
              backgroundColor: "#FFF",
              padding: "20px",
              borderRadius: 8,
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <Box
              display="flex"
              justifyContent={"space-between"}
              marginBottom="1rem"
            >
              <Typography variant="h4" style={{ margin: 0 }}>
                {showingPhoto?.productName}
              </Typography>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={handleCloseModal}
              >
                <Typography variant="caption">Fechar</Typography>
                <CloseIcon
                  onClick={handleCloseModal}
                  style={{ marginLeft: "0.5rem" }}
                />
              </Box>
            </Box>

            {showingPhoto &&
              showingPhoto.images &&
              showingPhoto.images.length > 0 && (
                <>
                  <Box
                    display="flex"
                    justifyContent="center"
                    marginBottom="1rem"
                  >
                    <img
                      alt={`Imagem ${currentImageIndex + 1}`}
                      src={
                        showingPhoto.images[currentImageIndex]?.base64 ||
                        showingPhoto.images[currentImageIndex]?.Url
                      }
                      style={{
                        width: "50vw",
                        maxHeight: "500px",
                        objectFit: "contain",
                      }}
                    />
                  </Box>

                  {showingPhoto.images.length > 1 && (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      marginTop="1rem"
                    >
                      <Button
                        variant="outlined"
                        onClick={handlePrevImage}
                        disabled={currentImageIndex === 0}
                      >
                        Anterior
                      </Button>

                      <Typography variant="body2">
                        {currentImageIndex + 1} de {showingPhoto.images.length}
                      </Typography>

                      <Button
                        variant="outlined"
                        onClick={handleNextImage}
                        disabled={
                          currentImageIndex === showingPhoto.images.length - 1
                        }
                      >
                        Próxima
                      </Button>
                    </Box>
                  )}

                  <Box display="flex" justifyContent="center" marginTop="1rem">
                    <Typography variant="caption" color="textSecondary">
                      {showingPhoto.images[currentImageIndex]?.name}
                    </Typography>
                  </Box>
                </>
              )}
          </div>
        </Fade>
      </Modal>
    </>
  );
}
